module.exports = __webpack_public_path__ + "img/CS-UltraLine-II-User.ecf32943.jpg";